import { InfoCard } from '@backstage/core-components';
import { RiDeleteBinLine } from '@remixicon/react';
import { infraCardStyles } from '../ui/InfraPrimitives';
import { DestroyInfrastructureButton } from './DestroyInfrastructureButton';

export const DestroyInfrastructureCard = () => {
  return (
    <InfoCard title="Danger Zone" icon={<RiDeleteBinLine size={20} />}>
      <div className={infraCardStyles.flexEnd}>
        <DestroyInfrastructureButton />
      </div>
    </InfoCard>
  );
};
